export default {
  couldNotCopyFieldToClipboard: 'Could not copy field to clipboard',
  customFieldSuccessfullyCopiedToClipboard: 'Custom field successfully copied to clipboard',
  copyCustomizedField: 'Customize',
  unsubscribeLink: 'Unsubscribe link',
  saveContinue: 'Save and continue',
  notSavedTemplate: 'This template was not saved successfully',
  chooseTemplate: 'Choose one or create a new template',
  templates: 'Templates',
  createTemplate: 'Create new template',
  templateSuccessfullyUpdated: 'Template successfully updated',
  templateSuccessfullySaved: 'Template successfully saved',
  labelTemplate: 'Template name',
  titleRequired: 'Template name required',
  searchInput: 'Search templates',
  resumenReady: '¡We´re ready!',
  resumeSubtitle: 'Your campaign is ready to be sent.',
  resumeDraftSubtitle: 'Your campaign is getting ready to be sent',
  reach: 'People in this campaign',
  messagesToSend: 'Messages to send',
  sentMessages: 'Sent messages',
  sender: 'Sender',
  subject: 'Subject',
  attachments: 'Attachments',
  schedule: 'Schedule',
  scheduled: 'Scheduled',
  sendedCampaign: 'Your campaign has been sent!',
  scheduledCampaign: 'Your campaign was scheduled!',
  sendedCampaignSubtitle: 'Your campaign was sent correctly, you can see the results in the summary section',
  scheduledCampaignSubtitle: 'Your campaign was saved correctly, you can see the results in the summary section',
  titleCampaigns: 'Campaigns',
  sent: 'Sent',
  campaignSent: 'Campaign Sent',
  campaignScheduled: 'Scheduled',
  allSent: 'All sent',
  recently: 'Most recent',
  draft: 'Draft',
  inReview: 'In review',
  sending: 'Sending',
  fileWithSameNameAlreadyExists: 'A file with the same name already exists',
  opened: 'Open',
  softBounced: 'Soft bounced',
  hardBounced: 'Hard bounced',
  hardBouncedHelper: 'Hard bounces happen when an email can\'t be delivered. This can be caused by an invalid email address or an unexpected error during sending.',
  clicks: 'Clicks',
  totalDelivered: 'Delivered',
  rejected: 'Rejected',
  rejectedReason: 'Reason of rejection',
  deferral: 'Deferred',
  gotoCampaingList: 'See all your campaigns and templates',
  introTitle: 'Outbound campaigns to increase awareness',
  introDescription: 'Create a campaign using the following channels:',
  labelCampaign: 'Campaign name',
  segmentSelect: 'Select a segment',
  segmentTitle: 'Select the segment you want to send the message to',
  segmentWarning: 'Message limits determine how many unique users your business can message on a daily basis. This number depends on the level of active users per month your company has. All companies start at level 1, that meaning they can send up to 1,000 messages to new users in 24 hours, level 2, 10,000 and level 3, 100,000. Templates that fail to be sent in one day will be sent the next day and so on. If your business is not at level 2 or level 3, we advise you not to send mass campaigns to lists that are too large, as you could end the number of templates allowed in one day. day or could arrive days later.',
  attachTitle: 'Attachments',
  attachSubtitle: 'You can attach files to your Email campaign, each file must weigh less than 5MB and the total weight of all the files attached must not exceed 24MB. Keep in mind that attachments can affect the success of your email campaigns',
  attachIndication: 'Drag the files you want to attach here',
  attachFile: 'Attach files',
  sizeOfFileCantExceed: 'The maximum size of each file cannot exceed {size} {units}',
  filesTotalSizeMustBeSmallerThan: 'The total size of your files cannot exceed {size} {units}',
  almostDone: '¡You´re almost done!',
  viewmoreTemplates: 'See more templates',
  noInfo: 'You don´t have ',
  noInfoPart2: ' created',
  createCampaingbtn: 'Create a campaign',
  campaignDelivered: 'DELIVERED',
  campaignInReview: 'IN REVIEW',
  campaignRejected: 'REJECTED',
  campaignPending: 'PENDING',
  campaignAllFilter: 'ALL',
  campaignUsers: 'People in this campaign',
  sendCampaign: 'Send now',
  campaignSenderCopy: 'Who\'s sending?',
  campaignExport: 'Export campaign users',
  successfullCampaignExport: 'You\'ll receive a link with your campaign report',
  unsuccesfullCampaignExport: 'Your campaign report was not generated',
  campaignArchived: 'Campaign archived successfully',
  campaignNotArchived: 'Campaign failed to be archived',
  campaignImportingCouldHaveDelays: 'Campaign import may be delayed',
  campaignDeliveryMayBeDelayed: 'Campaign delivery may be delayed',
  campaignType: 'Type',
  resumeReady: 'Ready to go!',
  resumeDraft: 'Almost ready to go!',
  campaignError: 'Error sending the campaign',
  campaignEmpty: 'Your campaign doesn\'t have people enrolled',
  campaignImportingUsers: 'Your campaign is still importing users, wait a moment',
  sendDate: 'Send date',
  smsAprox: 'SMS',
  msgWaitingCampaign: 'Sending the campaign may take a while to finish'
}
